import { createSelector } from '@reduxjs/toolkit';

import { getLoggedInUserOrganization, isLoggedInUserRoot } from '@paragon/login-tools';

/** Component-summary downloads are limited to root users and these partner organizations. */
const COMPONENT_SUMMARY_ORGANIZATIONS = ['Clearspan Components Inc.', 'Lam-Wood Systems'];

export const canDownloadComponentSummary = createSelector(
  [isLoggedInUserRoot, getLoggedInUserOrganization],
  (isRoot, organization) => isRoot || (organization != null && COMPONENT_SUMMARY_ORGANIZATIONS.includes(organization)),
);
